import * as React from 'react';
export const vouchSvg = React.forwardRef(function vouchSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#3BE0AD',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#0F1C2C',
      d: 'M8.718 16.068c0-1.699.88-2.667 2.431-2.667 1.552 0 2.433.963 2.433 2.667 0 1.704-.88 2.666-2.433 2.666-1.551 0-2.431-.951-2.431-2.666Zm3.283 0c0-.965-.37-1.3-.851-1.3-.44 0-.852.335-.852 1.3 0 .964.411 1.3.851 1.3s.852-.336.852-1.3Zm6.762 0c0-1.715.95-2.667 2.36-2.667s2.187.717 2.253 2.028h-1.573c-.072-.537-.294-.691-.677-.691-.511 0-.782.4-.782 1.33 0 .91.293 1.33.782 1.33.39 0 .605-.134.677-.693h1.573c-.059 1.314-.923 2.03-2.234 2.03-1.511 0-2.38-.98-2.38-2.667Zm5.091-2.5h1.5v1.829H26.5v-1.829H28v5h-1.5v-1.846h-1.145v1.845h-1.501v-4.999Zm-9.817.002h1.478v3.208c0 .394.204.71.599.71.434 0 .691-.268.691-.94v-2.98h1.48v4.992h-1.48v-.586c-.176.425-.688.726-1.22.726-1.006 0-1.548-.655-1.548-1.742V13.57Zm-6.995-.002-.684 3.277-.692-3.277H4l1.495 5h1.718l1.505-5H7.042Zm14.103 6.267c-.88 0-1.5-.282-2.065-.709h-1.926c.881 1.256 2.3 2.025 3.993 2.025 1.692 0 3.107-.77 3.992-2.025h-1.925c-.567.427-1.187.71-2.066.71M13.92 11.78a4.93 4.93 0 0 0-2.712-.78 4.875 4.875 0 0 0-2.701.78 4.7 4.7 0 0 0-1.251 1.204H9.2c.553-.403 1.161-.67 2.005-.67s1.457.267 2.017.67h1.96a4.745 4.745 0 0 0-1.26-1.204',
    }),
  );
});
vouchSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var vouch = {
  category: 'brand',
  colorable: false,
  name: 'vouch',
  svg: vouchSvg,
};
